import { withHandlers, compose } from 'recompose'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as OrgActions from 'modules/org/actions'

import SignupChoiceCard from './component'
import * as RoutingSelectors from 'modules/routing/selectors'
import * as OrgSelectors from 'modules/org/selectors'

const mapStateToProps = state => ({
  search: RoutingSelectors.getSearch(state),
  pathname: RoutingSelectors.getPathname(state),
  oauthError: OrgSelectors.getOAuthError(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    exchangeGoogleCodeForDriftCode: OrgActions.exchangeGoogleCodeForDriftCode,
    exchangeMicrosoftCodeForDriftCode: OrgActions.exchangeMicrosoftCodeForDriftCode
  }, dispatch),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onProcessingGoogleCode: props => event => {
      if (event.code) {
        props.actions.exchangeGoogleCodeForDriftCode({ code: event.code, externalRedirect: false, pathname: props.pathname })
      }
    },
    onProcessingExternalGoogleCode: props => event => {
      props.actions.exchangeGoogleCodeForDriftCode({ code: event, externalRedirect: true, pathname: props.pathname })
    },
    onProcessingMicrosoftCode: props => event => {
      if (event) {
        props.actions.exchangeMicrosoftCodeForDriftCode({ code: event, pathname: props.pathname })
      }
    },
  }),
)(SignupChoiceCard)



// WEBPACK FOOTER //
// ./src/layouts/SignupChoiceCard/index.js